import { Fragment } from 'react';
import { createPortal } from 'react-dom';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface MetaTagsProps {
  // No props needed since metadata is handled by usePageMetadata hook
}

/**
 * Detect current language from URL for og:locale
 */
const getOgLocale = (): string => {
  if (typeof window === 'undefined') return 'en_US';

  const pathPart = window.location.pathname.split('/').find(Boolean);
  const langCode = pathPart;

  const localeMap: Record<string, string> = {
    en: 'en_US',
    ko: 'ko_KR',
    ja: 'ja_JP',
    zh: 'zh_CN',
    vi: 'vi_VN',
    ru: 'ru_RU',
    ar: 'ar_SA',
    th: 'th_TH',
    id: 'id_ID',
    es: 'es_ES',
  };

  return localeMap[langCode ?? 'en'] ?? 'en_US';
};

const MetaTags = (_props: MetaTagsProps) => {
  if (typeof document === 'undefined') return null;

  // Get locale for OpenGraph
  const ogLocale = getOgLocale();

  return createPortal(
    <Fragment>
      {/* Note: Meta description and robots are managed by usePageMetadata hook to avoid duplicates */}
      {/* Meta tags */}

      {/* Sitemap reference */}
      <link rel="sitemap" type="application/xml" title="Sitemap" href="/sitemap-index.xml" />

      {/* Note: Open Graph and Twitter Card tags are managed by usePageMetadata hook to avoid duplicates */}
      {/* Only basic OG tags are set here as fallbacks for initial page load */}
      <meta property="og:site_name" content="Medipaths" />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content={ogLocale} />

      {/* Twitter Card - Basic fallback */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@medipaths" />

      {/* Additional SEO */}
      <meta name="application-name" content="Medipaths" />
      <meta name="apple-mobile-web-app-title" content="Medipaths" />

      {/* Viewport */}
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=5" />

      {/* Theme color */}
      <meta name="theme-color" content="var(--white, #ffffff)" />

      {/* Note: Canonical URL is managed by usePageMetadata hook to avoid duplicates */}

      {/* Preconnect and DNS prefetch */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
    </Fragment>,
    document.head
  );
};

export default MetaTags;
